// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__12Mvz","title":"ClientReferral_title__DNbIs","itemText":"ClientReferral_itemText__2sWVi"};